
import { StartUp02Icon } from '@hugeicons/react'

import {
  LevelPlayStartCardQuiz,
  LevelPlayStartHeading,
  LevelPlayStartHero
} from '@/shared/level-play/start-screen'
import { useQuizzesProgresses } from '@/shared/hooks/useQuizzesProgresses'
import { Button } from '@/shared/ui/Button'
import { LevelPlay } from '@/shared/ui/LevelPlay'

import { DigitalProductQuizQuizBlocked } from './Blocked'
import { useQuizContext } from '../../context'

export const DigitalProductQuizQuizzesQuestionsInitial = ({ step }) => {
  const { quiz, hearts, questions, onQuestionStart } = useQuizContext()
  const { isLocked } = useQuizzesProgresses({ id: quiz.id })

  if (isLocked) return <DigitalProductQuizQuizBlocked />
  return (
    // `customContent` faz deste componente o filho direto do form, então é ele
    // que carrega a corrente de flex — sem isso a coluna dimensiona pelo conteúdo
    // e o footer larga a base.
    <div className="flex min-h-0 flex-1 flex-col">
      <LevelPlay.Body
        id={step.id}
        className="flex flex-col items-center justify-center px-4"
      >
        <div className="flex w-full flex-col items-center gap-4">
          <LevelPlayStartHero variant="quiz" />
          <LevelPlayStartHeading
            hearts={hearts}
            challengeCount={questions.length}
          />
        </div>
        {quiz && (
          <LevelPlayStartCardQuiz className="mt-10" name={quiz.name} />
        )}
      </LevelPlay.Body>
      <LevelPlay.Footer id={step.id}>
        <Button
          variant="primary"
          size="md"
          className="grow"
          leadingIcon={<StartUp02Icon variant="duotone" size={20} />}
          onClick={onQuestionStart}
        >
          Sim, começar!
        </Button>
      </LevelPlay.Footer>
    </div>
  )
}
